import { useState } from 'react';
import { DIAS_MAXIMOS_DE_ANTICIPACION } from '@medchoice/shared';
import { Icono } from '../../ui';

const DIAS_DE_LA_SEMANA = ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'];

export function aIso(fecha: Date): string {
  return `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, '0')}-${String(fecha.getDate()).padStart(2, '0')}`;
}

function hoy(): Date {
  const f = new Date();
  return new Date(f.getFullYear(), f.getMonth(), f.getDate());
}

interface PropsCalendario {
  elegida: string | null;
  alElegir: (fecha: string) => void;
}

/** Desde hoy hasta el límite de anticipación. Los domingos no se atiende. */
export function Calendario({ elegida, alElegir }: PropsCalendario) {
  const primero = hoy();
  const ultimo = new Date(primero.getFullYear(), primero.getMonth(), primero.getDate() + DIAS_MAXIMOS_DE_ANTICIPACION);
  const [mes, setMes] = useState(new Date(primero.getFullYear(), primero.getMonth(), 1));

  const diasDelMes = new Date(mes.getFullYear(), mes.getMonth() + 1, 0).getDate();
  // La semana arranca el lunes: getDay() da 0 para el domingo.
  const huecos = (mes.getDay() + 6) % 7;
  const puedeRetroceder = mes > new Date(primero.getFullYear(), primero.getMonth(), 1);
  const puedeAvanzar = new Date(mes.getFullYear(), mes.getMonth() + 1, 1) <= ultimo;
  const titulo = mes.toLocaleDateString('es-AR', { month: 'long', year: 'numeric' });

  return (
    <div className="calendario">
      <div className="calendario__cabecera">
        <button type="button" className="calendario__flecha" disabled={!puedeRetroceder} aria-label="Mes anterior"
          onClick={() => setMes(new Date(mes.getFullYear(), mes.getMonth() - 1, 1))}>
          <Icono nombre="chevron-left" tamano={18} />
        </button>
        <span className="calendario__mes">{titulo}</span>
        <button type="button" className="calendario__flecha" disabled={!puedeAvanzar} aria-label="Mes siguiente"
          onClick={() => setMes(new Date(mes.getFullYear(), mes.getMonth() + 1, 1))}>
          <Icono nombre="chevron-right" tamano={18} />
        </button>
      </div>
      <div className="calendario__grilla" role="grid" aria-label={titulo}>
        {DIAS_DE_LA_SEMANA.map((d) => <span key={d} className="calendario__dia-semana">{d}</span>)}
        {Array.from({ length: huecos }, (_, i) => <span key={`hueco-${i}`} />)}
        {Array.from({ length: diasDelMes }, (_, i) => {
          const fecha = new Date(mes.getFullYear(), mes.getMonth(), i + 1);
          const iso = aIso(fecha);
          const habilitado = fecha >= primero && fecha <= ultimo && fecha.getDay() !== 0;
          const clases = ['calendario__dia', iso === elegida && 'calendario__dia--elegido', iso === aIso(primero) && 'calendario__dia--hoy']
            .filter(Boolean).join(' ');
          return (
            <button key={iso} type="button" className={clases} disabled={!habilitado}
              aria-pressed={iso === elegida} onClick={() => alElegir(iso)}>
              {i + 1}
            </button>
          );
        })}
      </div>
    </div>
  );
}
